import { ItemInputSelect } from 'types/ItemInputSelect';

export const position: ItemInputSelect[] = [
  { id: 'bottom-right', textOption: 'customTags.bottomRight' },
  { id: 'bottom-left', textOption: 'customTags.bottomLeft' },
  { id: 'top', textOption: 'customTags.top' },
  { id: 'description', textOption: 'customTags.description' },
];
